"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import Context from "./RadioGroup.context.js";
const RadioGroupControlled = (props) => {
    const { onChange, name, disabled, value, children, hasError } = props;
    const handleChange = ({ event, value }) => {
        if (!value)
            return;
        if (onChange)
            onChange({ name, value, event });
    };
    return (_jsx(Context.Provider, { value: { onChange: handleChange, disabled, value, name, hasError }, children: children }));
};
RadioGroupControlled.displayName = "RadioGroupControlled";
export default RadioGroupControlled;
